"use strict";

exports.__esModule = true;
var _Hero = _interopRequireDefault(require("./Hero"));
exports.default = _Hero.default;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}